import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get } from '../../modules/apAutomation/apIngestion';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const apIngestionId = _.get(ownProps, ['match', 'params', 'apIngestionId']);
	const apIngestion = apIngestionId ? _.get(state.maps, ['apIngestion', apIngestionId]) : undefined;

	return {
		apIngestion,
		userMap: state.maps.user,
		carrierMap: state.maps.carrier,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		resourceMap: state.maps.resource,
		stationDeliveryMap: state.maps.stationDelivery,
		stationInvoiceMap: state.maps.stationInvoice,
		apIngestionDocumentMap: state.maps.apIngestionDocument,
		stationMap: state.maps.station,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			apIngestionAdd: add,
			apIngestionUpdate: update,
			apIngestionGet: get,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
